var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "enterprise-step3" }, [
      _c("img", {
        attrs: { src: require("@/assets/image/icon_step3.png"), alt: "" },
      }),
      _c("div", { staticClass: "text" }, [
        _vm._v("恭喜您，试用申请提交成功！"),
      ]),
      _c("div", { staticClass: "tips" }, [
        _vm._v("审核通过后，客服将尽快和您联系，请您耐心等待..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }